/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
import{ViewingMode as e}from"../../../../ViewingMode.js";class t{constructor(e,t,i,r,s){this.rctx=e,this.viewingMode=t,this.stippleTextures=i,this.waterTextures=r,this.markerTextures=s}get spherical(){return this.viewingMode===e.Global}get doublePrecisionRequiresObfuscation(){return this.rctx.driverTest.doublePrecisionRequiresObfuscation.result}}export{t as ShaderTechniqueConstructionContext};
